import s from './GigAssMessage.module.sass'
import { Message } from '../../model/types'

import React, { FC, useMemo, useEffect, useState } from 'react'

import { RestCard } from '@widgets/Restaurant/RestCards/RestCard'
import { useClientResponsive } from '@shared/lib/hooks/useClientResponsive'

import { Text } from '@shared/ui/Typography/Text'
import { Title } from '@shared/ui/Typography/Title'

import { assistantMockConclusionRestResponses } from '@widgets/Common/GigAssist/model/mock'
import { Carousel } from '@shared/ui/Layout/Carousel'
import { useAppDispatch } from '@app/model/store'
import { TypeMappingRestOutput } from '@shared/api/middleware/mappingAPI/restaurant/type'
import IconTailMessage from '@icons/gigachat/tail-message.svg'

interface Props {
  message: Message
  asElement?: React.ElementType
}

/**
 * @function GigAssMessage - компонент сообщения в чате.
 * @todo данный файл должен импортировать в себя компонент сообщения,
 *    например из @shared/ui/Layout/Chat/Message/Message.tsx,
 *    и использовать его для отображения сообщения,
 *    а данный компонент будет являться оберткой для UI компонентов,
 *    и будет содержать в себе дополнительную логику, например аналитику.
 */
const GigAssMessage: FC<Props> = (props) => {
  const { message, asElement: Component = 'div' } = props

  const { text, isBot, timestamp, restaurants: messageRestaurants, tag } = message

  const { isMobile } = useClientResponsive()
  const [isVisible, setIsVisible] = useState(false)
  const dispatch = useAppDispatch()

  useEffect(() => {
    // небольшая задержка для плавного появления
    const timer = setTimeout(() => {
      setIsVisible(true)
    }, 10)

    return () => clearTimeout(timer)
  }, [])

  // используем только полные данные ресторанов из API
  const restaurants = useMemo(() => {
    if (messageRestaurants && messageRestaurants.length > 0) return messageRestaurants
    return undefined
  }, [messageRestaurants])

  // console.log('!!! GigAssMessage message', message)
  // console.log('!!! GigAssMessage text', text)
  // console.log('!!! GigAssMessage isBot', isBot)
  // console.log('!!! GigAssMessage restaurants', restaurants)

  // console.log('!!! GigAssMessage messageRestaurants', {
  //   messageRestaurants,
  //   type: typeof messageRestaurants,
  //   length: messageRestaurants?.length,
  // })

  const restaurantCards = useMemo(() => {
    // console.log('!!! GigAssMessage useMemo restaurants', {
    //   restaurants,
    //   type: typeof restaurants,
    //   length: restaurants?.length,
    // })

    // фильтруем только рестораны с полной структурой TypeMappingRestOutput
    const filteredRestaurants = restaurants?.filter(
      (restaurant): restaurant is TypeMappingRestOutput =>
        restaurant &&
        typeof restaurant === 'object' &&
        'id' in restaurant &&
        !!restaurant.id &&
        'images' in restaurant &&
        restaurant.images &&
        typeof restaurant.images === 'object',
    )
    // console.log('!!! GigAssMessage filteredRestaurants', filteredRestaurants)
    // console.log('!!! GigAssMessage filteredRestaurants length', filteredRestaurants?.length)

    const cards = filteredRestaurants?.map((restaurant, idx) => {
      // console.log('!!! GigAssMessage render RestCard', restaurant, {
      //   id: restaurant.id,
      //   name: restaurant.name,
      //   price: restaurant.price,
      //   address: restaurant.address,
      //   discounts: restaurant.discounts,
      //   schedule: restaurant.schedule,
      //   images: restaurant.images,
      // })
      return (
        <RestCard
          type='gig-assist'
          key={restaurant.id}
          data={restaurant}
          onClickInsteadLink={() => window.open(restaurant.url.path, '_blank')}
          // additionalData={{ conclusion: restaurant.conclusion || null }}
          sizes='M'
          analytic={{
            section_name: 'gigachat',
            section_index: idx,
            advertCardPlaceType: 'search',
          }}
        />
      )
    })
    // console.log('!!! GigAssMessage cards', cards)
    // console.log('!!! GigAssMessage cards length', cards?.length)
    return cards
  }, [restaurants])

  return (
    <li
      className={`${s.message} ${isBot ? s.messageBot : s.messageUser} ${isVisible ? s.visible : ''}`}
      data-timestamp={timestamp}
      data-type={isBot ? 'bot' : 'user'}>
      <div className={s.messageContent}>
        {isBot && tag && (
          <Title tag='h4' sizes='h4' className={s.messageTitle} children={`Подборка ресторанов: "${tag}"`} />
        )}

        <Text className={s.messageText} sizes='M' tag='p' children={text} />
        {!isBot && <IconTailMessage className={s.messageTailIcon} />}
        <Text
          data-hidden
          className={s.messageMeta}
          sizes='M'
          tag='p'
          children={new Date(timestamp).toLocaleTimeString()}
        />

        {isBot && restaurantCards && restaurantCards.length > 0 && (
          <div className={s.chatRestsWrapper}>
            <Carousel>
              <Carousel.Slider className={s.chatRests} spacingDesktop={8}>
                {restaurantCards}
              </Carousel.Slider>
            </Carousel>
          </div>
        )}
      </div>
    </li>
  )
}

export default GigAssMessage
